import React, { ReactElement, useState, useEffect, useContext } from "react";
import { Form } from "react-bootstrap";
import { useLocation } from "react-router";
import { useNavigate } from "react-router";
import { ApiService } from "../../../services/api.service";
import Loader from "../../Loader";
import AdminHeader from "../shared/header";
import AdminNav from "../shared/nav";
import { SearchContext } from "../../../context/searchContext";
import { FormatBasePriceTest, FormatGeneralPrice } from "../../../helpers";
import { ExchangeContext } from "../../../context/exchangeContext";
import { format } from "path";

function Products(): ReactElement {
  const {
    searchText,
    setSearchText,
    searchData,
    setSearchData,
    searchType,
    setSearchType,
  } = useContext(SearchContext);

  const { exchangeData } = useContext(ExchangeContext);

  console.log("Exchange Data", JSON.stringify(exchangeData));

  const location = useLocation();

  interface Product {
    productID: number;
    productName: string;
    productPriceDollar: number;
    productPriceGBP: number;
    productPriceEuro: number;
    productStatus: string;
  }

  if (location.pathname.includes("Administration")) {
    var el = document.getElementById("MAheader");
    if (el !== null) {
      el.style.display = "none";
    }
  }

  function FormatGeneralPrice(userData: any, number: number) {
    if (userData.currency === 1) {
      return number.toLocaleString("en-US", {
        //USD
        style: "currency",
        currency: "USD",
      });
    } else if (userData.currency === 2) {
      //GBP
      return number.toLocaleString("en-GB", {
        style: "currency",
        currency: "GBP",
      });
    } else if (userData.currency === 3) {
      //Euro
      return number.toLocaleString("de-DE", {
        style: "currency",
        currency: "EUR",
      });
    }
  }

  const handlePricing = (user: any, price: any) => {
    let newcalc = FormatBasePriceTest(user, exchangeData, price);
    return FormatGeneralPrice(user, newcalc ?? 0); // Default to 0 if undefined
  };

  // Simplified User Objects for different categories
  const createUser = (
    userID: any,
    userName: any,
    userEmail: any,
    currency: any,
    priceClassID: any
  ) => ({
    userID,
    userName,
    userEmail,
    currency,
    priceClassID,
  });

  // Users
  const europeUser = createUser(1, "Europe User", "europe@ma.com", 3, 1); // Euro, Europe
  const europeUserDollar = createUser(1, "Europe User", "europe@ma.com", 1, 1); // Euro, USD

  const usaUser = createUser(1, "USA User", "usa@ma.com", 1, 0); // USD, No price class
  const ukUser = createUser(1, "UK User", "uk@ma.com", 2, 1); // GBP, Europe
  const ukDomestic = createUser(1, "UK Domestic", "ukdomestic@ma.com", 2, 2); // GBP, Domestic
  const euroDomestic = createUser(
    1,
    "Euro Domestic",
    "europedomestic@ma.com",
    3,
    2
  ); // Euro, Domestic
  const ukInternational = createUser(
    1,
    "UK International",
    "ukinternational@ma.com",
    2,
    3
  ); // GBP, International
  const euroInternational = createUser(
    1,
    "Euro International",
    "europinternational@ma.com",
    3,
    3
  ); // Euro, International
  const domesticUser = createUser(1, "Domestic User", "domestic@ma.com", 1, 2); // USD, Domestic
  const internationalUser = createUser(
    1,
    "International User",
    "international@ma.com",
    1,
    3
  ); // USD, International

  const [loading, setLoading] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState("");

  const [products, setProducts] = useState([]);

  const navigate = useNavigate();

  function handleClick(item: any) {
    navigate("/Administration/ProductEdit?id=" + item);
  }

  const handleKeyword = (e: any) => {
    const uppercasedValue = e?.toUpperCase();

    if (e.length >= 5) {
      setLoading(true);
      setSearchText(uppercasedValue);
      setSearchKeyword(uppercasedValue);
      const apiService = new ApiService();
      const fetchProductsByKeyword = async () => {
        const response = await apiService.getProductsByKeyword(uppercasedValue);
        setProducts(response);
        setLoading(false);
        setSearchData(response);
        setSearchType("Products");
      };

      fetchProductsByKeyword();
    }
  };

  // useEffect(() => {
  //   if (searchData && searchType === "Products") {
  //     setProducts(searchData);
  //   }
  // }, []);

  return (
    <div>
      <AdminHeader></AdminHeader>

      <div className="container-fluid">
        <div className="row">
          <AdminNav></AdminNav>
          <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
              <h1 className="h2">Products</h1>
              {/* <div className="btn-toolbar mb-2 mb-md-0">
                <div className="btn-group me-2">
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary"
                  >
                    Share
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary"
                  >
                    Export
                  </button>
                </div>
                <button
                  type="button"
                  className="btn btn-sm btn-outline-secondary dropdown-toggle"
                >
                  <span
                    data-feather="calendar"
                    className="align-text-bottom"
                  ></span>
                  This week
                </button>
              </div> */}
            </div>

            <Form>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>Product Search</Form.Label>
                <Form.Control
                  type="search"
                  placeholder="Enter keyword"
                  style={{
                    textAlign: "left",
                    marginBottom: "0px",
                    textTransform: "uppercase", // Ensures the input displays uppercase
                  }}
                  onChange={(e) => handleKeyword(e.target.value)}
                />
                <Form.Text className="text-muted">
                  Type to search for a product
                </Form.Text>
              </Form.Group>
            </Form>

            {loading ? (
              <Loader />
            ) : products.length != 0 ? (
              <div className="table-responsive">
                <table className="table table-striped table-sm">
                  <thead>
                    <tr>
                      <th scope="col" style={{ width: "10%" }}>
                        Catalogue Image
                      </th>
                      <th scope="col">Orcl ID</th>
                      <th scope="col">Name</th>
                      <th scope="col">Master ($)</th>
                      <th scope="col">OR (GBP)</th>
                      <th scope="col">OR (Euro)</th>
                      <th scope="col">Eur User</th>
                      <th scope="col">Dom User</th>
                      <th scope="col">Int User</th>
                      <th scope="col">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {products &&
                      products.map((item: Product) => (
                        <tr
                          style={{ cursor: "pointer" }}
                          onClick={() => handleClick(item.productID)}
                        >
                          <td style={{ width: "10%" }}>
                            <img
                              src={`${window.location.origin}/admin/catalogue/${item.productName}.jpg`}
                              style={{ maxWidth: "60px" }}
                              alt="NO IMAGE"
                            />
                          </td>
                          <td>{item.productID}</td>
                          <td>{item.productName}</td>

                          {/* Master Price in USD, GBP, and Euro */}
                          <td>
                            {/* {FormatGeneralPrice(
                              usaUser,
                              item?.productPriceDollar
                            )} */}
                          </td>
                          <td>
                            {/* {FormatGeneralPrice(usaUser, item?.productPriceGBP)} */}
                          </td>
                          <td>
                            {/* {FormatGeneralPrice(
                              usaUser,
                              item?.productPriceEuro
                            )} */}
                          </td>

                          {/* Europe User Prices */}
                          <td>
                            {handlePricing(
                              europeUserDollar,
                              item.productPriceDollar
                            )}{" "}
                            <br />
                            GBP:{" "}
                            {handlePricing(
                              ukUser,
                              item.productPriceDollar
                            )}{" "}
                            <br />
                            Euro:{" "}
                            {handlePricing(europeUser, item.productPriceDollar)}
                          </td>

                          {/* Domestic User Prices */}
                          <td>
                            {handlePricing(
                              domesticUser,
                              item.productPriceDollar
                            )}{" "}
                            <br />
                            GBP:{" "}
                            {handlePricing(
                              ukDomestic,
                              item.productPriceDollar
                            )}{" "}
                            <br />
                            Euro:{" "}
                            {handlePricing(
                              euroDomestic,
                              item.productPriceDollar
                            )}
                          </td>

                          {/* International User Prices */}
                          <td>
                            {handlePricing(
                              internationalUser,
                              item.productPriceDollar
                            )}{" "}
                            <br />
                            GBP:{" "}
                            {handlePricing(
                              ukInternational,
                              item.productPriceDollar
                            )}{" "}
                            <br />
                            Euro:{" "}
                            {handlePricing(
                              euroInternational,
                              item.productPriceDollar
                            )}
                          </td>

                          <td>{item.productStatus}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            ) : null}
          </main>
        </div>
      </div>
    </div>
  );
}
export default Products;
